
    import { Component, Vue } from 'vue-property-decorator';
    import {__, capitalize} from "@/helpers/utils";

    @Component({
        components: {
        },
        props: {
            status: String,
            count: Number,
        },
        computed: {
            style() {
                let color = '#50B83C';
                switch (this.$props.status) {
                    case 'new':
                        color = '#EEC200';
                        break;
                    case 'approved':
                        color = '#50B83C';
                        break;
                    case 'denied':
                    case 'cancelled':
                        color = '#ED6347';
                }

                return `border-color: ${color}; color: ${color}`;
            }
        }
    })
    export default class ApplicationCounter extends Vue {

        private translate(term: string) {
            return __(term).toUpperCase();
        }
    }
